import { render, staticRenderFns } from "./AddImsUserDialog.vue?vue&type=template&id=b0bd2300&scoped=true&"
import script from "./AddImsUserDialog.vue?vue&type=script&lang=js&"
export * from "./AddImsUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bd2300",
  null
  
)

export default component.exports